import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CoreRadioChips from 'shared/chips/CoreRadioChips';
import useCommonStore from 'store/useCommonStore';
import { PlatformCode, PlatformName } from 'type/common';

const chips_arr = ['Instagram', 'Youtube', 'Naver Blog', 'TikTok'];

const code_mapper: Record<PlatformName, PlatformCode> = {
	Instagram: 'ig',
	Youtube: 'yt',
	'Naver Blog': 'nb',
	TikTok: 'tt',
};

const MatchSelectPlatformRow = () => {
	// router
	const navigate = useNavigate();
	// store
	const { platform, setPlatform, setCommonFilter } = useCommonStore();

	/** 플랫폼 변경
	 * @params (화면에서 보여지는) 변경할 플랫폼의 이름*/
	const setPlatformChips = (platform_name: string) => {
		setPlatform({
			name: platform_name as PlatformName,
			code: code_mapper[platform_name as PlatformName],
		});
		navigate('?page=1');

		// 플랫폼 변경 시 common filter 초기화
		setCommonFilter('order_by', 'random');
		setCommonFilter('order', 'desc');
	};

	useEffect(() => {
		if (platform.name === null) setPlatform({ name: 'Instagram', code: 'ig' });
	}, [platform]);

	return (
		<CoreRadioChips
			group_type="carousel"
			style_type="default"
			_width="max-content"
			chips_list={chips_arr}
			selected_chips={platform.name ?? ''}
			setSelectedChips={setPlatformChips}
			_disabled={[]}
		/>
	);
};

export default MatchSelectPlatformRow;
